export const SCHEMA_SENS_DT_DNT = [
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'scenario',
    col_name: 'Scenario',
    col_desc: 'Scenario',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'md',
    col_name: 'MD',
    col_desc: 'Measure Depth',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'z',
    col_name: 'z TVD',
    col_desc: 'true Vertical Depth',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'inclination',
    col_name: 'Inclination',
    col_desc: 'Inclination Angle',
    col_unit: 'deg',
    ui_editable: true,
    ui_show: true,
    data_type: 'float',
    decimal: 3
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'pipe_type',
    col_name: 'Pipe Type',
    col_desc: 'Pipe Type',
    col_unit: '-',
    ui_editable: true,
    ui_show: true,
    data_type: 'str',
    decimal: ''
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'F_drag',
    col_name: 'Axial Drag Force',
    col_desc: 'Axial Drag Force',
    col_unit: 'lbf',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'F_static',
    col_name: 'Axial Force Static',
    col_desc: 'Axial Force Static',
    col_unit: 'lbf',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'F_trip_in',
    col_name: 'Axial Force Trip In',
    col_desc: 'Axial Force Trip In',
    col_unit: 'lbf',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'F_trip_out',
    col_name: 'Axial Force Trip Out',
    col_desc: 'Axial Force Trip Out',
    col_unit: 'lbf',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'F_drilling',
    col_name: 'Axial Force Drilling',
    col_desc: 'Axial Force Drilling',
    col_unit: 'lbf',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'HL_static',
    col_name: 'Hook Load Static',
    col_desc: 'Hook Load Static',
    col_unit: 'lbf',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'HL_trip_in',
    col_name: 'Hook Load Trip In',
    col_desc: 'Hook Load Trip In',
    col_unit: 'lbf',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'HL_trip_out',
    col_name: 'Hook Load Trip Out',
    col_desc: 'Hook Load Trip Out',
    col_unit: 'lbf',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'Torque',
    col_name: 'Torque',
    col_desc: 'Torque',
    col_unit: 'ft-lbf',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  },
  {
    table_id: 'cd_drag_torque_sens',
    col_id: 'w_buckling',
    col_name: 'Wcr Buckling',
    col_desc: 'Wcr Buckling',
    col_unit: 'lb/ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 0
  }
];

export default SCHEMA_SENS_DT_DNT;
